var _path, _g, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoFgRgbWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 74,
    viewBox: "0 0 84 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_205_117",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 69,
    height: 74
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H69V74H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_205_117)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3893 22.9858H26.7814V16.628H16.3893V10.5963C16.3893 7.82483 17.526 6.60221 20.3675 6.60221H28.2429V0H18.9062C12.2487 0 8.75753 3.34181 8.75753 10.6777V16.628H-0.0107422V22.9858H8.75753V57.057H16.3893V22.9858ZM49.8396 74.011C61.5309 74.011 69.0002 67.1642 69.0002 55.6713V16.628H61.612V22.8227C59.6635 19.4807 55.6853 15.4868 48.6218 15.4868C38.8793 15.4868 32.0594 23.6379 32.0594 36.1089C32.0594 48.4984 38.9604 56.242 48.6218 56.242C55.523 56.242 59.7448 52.9814 61.612 49.721V55.5899C61.612 62.8442 57.1466 67.4902 49.8396 67.4902C42.8574 67.4902 39.4475 64.2299 38.2297 58.9317L30.7603 61.4585C32.5466 69.7726 39.6912 74.011 49.8396 74.011V74.011ZM50.7329 50.0471C44.5624 50.0471 39.9347 46.2976 39.9347 36.1089C39.9347 26.0017 44.5624 22.0076 50.7329 22.0076C57.2279 22.0076 61.8556 26.9797 61.8556 36.1089C61.8556 45.238 57.2279 50.0471 50.7329 50.0471V50.0471Z",
    fill: "#FFFFFE"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77 53.7394V53H80V53.7394H78.9026V57H78.0975V53.7394H77",
    fill: "#FFFFFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.1495 53L82.0182 55.7506H82.0288L82.8505 53H84V57H83.2354V54.1653H83.2251L82.3147 57H81.6853L80.7751 54.1934H80.7646V57H80V53H81.1495",
    fill: "#FFFFFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFgRgbWhite);
export default __webpack_public_path__ + "static/media/Logo-FG-RGB-white.bd8a8e0d9f36f5dc28907a15347e5148.svg";
export { ForwardRef as ReactComponent };